import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
    path:'/login',
    name:'login',
    component: resolve => require(['../view/admin/Login'],resolve)
  },{
    path:'/admin',
    name:'personInfo',
    login:true,
    component: resolve => require(['../view/admin/PersonInfo'],resolve),
    children: [{
      path:'/',
      component: resolve => require(['../view/admin/personMenu/Main'],resolve),
      children: [{
        path: '/',
        component: resolve => require(['../view/admin/personMenu/PersonIndex'],resolve)
      },{
        path:'update-user-info',
        component: resolve => require(['../view/admin/personMenu/UserInfo'],resolve)
      },{
        path: 'baidu-copy',
        component: resolve => require(['../view/admin/personMenu/BaiduCopy'],resolve)
      },{
        path: 'pan',
        component: resolve => require(['../view/admin/pan/index'],resolve)
      }]
    },{
      path:'user',
      name:'user',
      component: resolve => require(['../view/admin/system/UserManage'],resolve)
    },{
      path:'permission',
      name:'permission',
      component: resolve => require(['../view/admin/system/PermissionManage'],resolve)
    },{
      path:'role',
      name:'role',
      component: resolve => require(['../view/admin/system/RoleManage'],resolve)
    },{
      path: 'title',
      name:'userPermission',
      component: resolve => require(['../view/admin/skil/UserPermission'],resolve)
    },{
      path: 'writeEasy',
      name:'writeEasy',
      component: resolve => require(['../view/admin/skil/WriteEasy'],resolve)
    },{
      path: 'writeEasy2',
      name:'writeEasy2',
      component: resolve => require(['../view/admin/skil/WriteEasyTinymce'],resolve)
    },{
      path: 'editEasy/:easyId',
      component: resolve => require(['../view/admin/skil/WriteEasy'],resolve)
    },{
      path: 'editEasyTinymce/:easyId',
      component: resolve => require(['../view/admin/skil/WriteEasyTinymce'],resolve)
    },{
      path:'easyManager',
      component: resolve => require(['../view/admin/skil/EasyManager'],resolve)
    },{
      path:'tool',
      component: resolve => require(['../view/admin/skil/ToolManager'],resolve)
    },{
      path: 'userInfo',
      component: resolve => require(['../view/admin/system/UserInfo'],resolve)
    }]
  },{
    path: '/index/:username',
    name: 'index',
    component: resolve => require(['../view/index'],resolve),
    children:[{
      path:'/',
      name:'/first',
      component: resolve => require(['../view/first'],resolve) // 首页
    },{
      path: 'showEasy/:easyId',
      component: resolve => require(['../view/admin/skil/ShowEasy'],resolve)
    },{
      path: 'showEasyTinymce/:easyId',
      component: resolve => require(['../view/admin/skil/ShowEasyTinymce'],resolve)
    },{
      path: ":title",
      component: resolve => require(['../view/admin/TitleIndex'],resolve)
    }]
  },{
    path: '/403',
    component: resolve => require(['../view/admin/error/403'],resolve)
  },{
    path:'*',
    component: resolve => require(['../view/admin/error/404'],resolve)
  }]
});

// 解决 this.$route.push()   报错
Vue.use(Router)
// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js